/*
 * 接口统一集成模块
 */
import * as login from './moudules/login';
import * as menu from './moudules/menu';
import * as role from './moudules/role';
import * as department from './moudules/department';
import * as employee from './moudules/employee';
import * as user from './moudules/user';
import * as editlog from './moudules/editlog';
import * as otherUrl from './moudules/otherUrl';
import * as excel from './moudules/excel';
import * as report from './moudules/report';
import * as Material from './moudules/Material';
import * as position from './moudules/position';
import * as dictionary from './moudules/dictionary';
import * as staff from './moudules/staff';
import * as Region from './moudules/Region';
import * as Customer from './moudules/Customer';
import * as OrderPurchase from './moudules/OrderPurchase';
import * as Car from './moudules/Car';
import * as SysLogApi from './moudules/SysLogApi';
import * as MaterialIssueDoc from './moudules/stk/MaterialIssueDoc';

import * as system from './moudules/system';
import * as Reservation from './moudules/Reservation';
import * as Loadplace from './moudules/Loadplace';
import * as ThirdPartyInterface from './moudules/ThirdPartyInterface';
import * as MetrologyConfigurat from './moudules/MetrologyConfigurat';
import * as equipment from './moudules/equipment';
import * as Mailbox from './moudules/Mailbox';//信箱消息
import * as departure from './moudules/departure';
import * as Evaluation from './moudules/Evaluation';
import * as Pay from './moudules/Pay';
import * as access from './moudules/access';
import * as Sale from './moudules/Sale';
import * as certificate from './moudules/certificate';
import * as basis from './moudules/basis';
import * as SysPaymentChannel from './moudules/SysPaymentChannel';
// 默认全部导出
export default { 
  login,
  menu,
  role,
  department,
  employee,
  user,
  editlog,
  otherUrl,//地磅称重
  excel,
  report, 
  position,//职位
  Material,//商品（物料）
  dictionary,//字典
  staff, // 员工管理
  Region,//区域
  Customer,//往来单位（客户）
  OrderPurchase,//采购订单（包装物）
  Car,//车
  SysLogApi,//日志
  MaterialIssueDoc,//材料出库单

  system,//后台付费记录
  Reservation,//车运预约
  Loadplace,//装卸地
  ThirdPartyInterface,//第三方接口字段
  MetrologyConfigurat, //计量配置
  equipment,//设备管理
  Mailbox,
  departure,//废钢起运地、炉批号等
  Evaluation,//评价表
  Pay,
  access,//评铁
  Sale,//销售（报价/发货通知/提货单预留）
  certificate,//身份证ocr识别
  basis,
  SysPaymentChannel,
}



// WEBPACK FOOTER //
// ./src/api/api.js